/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_Hasachievements1Inputs */

const id_home_hero_hasachievements1 = /** @type {(inputs: Home_Hero_Hasachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memiliki pencapaian`)
};

const ms_home_hero_hasachievements1 = /** @type {(inputs: Home_Hero_Hasachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mempunyai pencapaian`)
};

const da_home_hero_hasachievements1 = /** @type {(inputs: Home_Hero_Hasachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Har achievements`)
};

const de_home_hero_hasachievements1 = /** @type {(inputs: Home_Hero_Hasachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hat Errungenschaften`)
};

const en_us2_home_hero_hasachievements1 = /** @type {(inputs: Home_Hero_Hasachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Has achievements`)
};

const es_es2_home_hero_hasachievements1 = /** @type {(inputs: Home_Hero_Hasachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con logros`)
};

const es_mx2_home_hero_hasachievements1 = /** @type {(inputs: Home_Hero_Hasachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiene logros`)
};

const fil_home_hero_hasachievements1 = /** @type {(inputs: Home_Hero_Hasachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`May achievements`)
};

const fr_home_hero_hasachievements1 = /** @type {(inputs: Home_Hero_Hasachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A des succès`)
};

const it_home_hero_hasachievements1 = /** @type {(inputs: Home_Hero_Hasachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ha risultati`)
};

const hu_home_hero_hasachievements1 = /** @type {(inputs: Home_Hero_Hasachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Van teljesítménye`)
};

const nl_home_hero_hasachievements1 = /** @type {(inputs: Home_Hero_Hasachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heeft prestaties`)
};

const no_home_hero_hasachievements1 = /** @type {(inputs: Home_Hero_Hasachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Har prestasjoner`)
};

const pl_home_hero_hasachievements1 = /** @type {(inputs: Home_Hero_Hasachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ma osiągnięcia`)
};

const pt_br2_home_hero_hasachievements1 = /** @type {(inputs: Home_Hero_Hasachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tem conquistas`)
};

const pt_home_hero_hasachievements1 = /** @type {(inputs: Home_Hero_Hasachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tem conquistas`)
};

const ro_home_hero_hasachievements1 = /** @type {(inputs: Home_Hero_Hasachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are realizări`)
};

const fi_home_hero_hasachievements1 = /** @type {(inputs: Home_Hero_Hasachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saavutuksia`)
};

const sv_home_hero_hasachievements1 = /** @type {(inputs: Home_Hero_Hasachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Har prestationer`)
};

const vi_home_hero_hasachievements1 = /** @type {(inputs: Home_Hero_Hasachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Có thành tích`)
};

const tr_home_hero_hasachievements1 = /** @type {(inputs: Home_Hero_Hasachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başarımları var`)
};

const cs_home_hero_hasachievements1 = /** @type {(inputs: Home_Hero_Hasachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Má úspěchy`)
};

const bg_home_hero_hasachievements1 = /** @type {(inputs: Home_Hero_Hasachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Има постижения`)
};

const ru_home_hero_hasachievements1 = /** @type {(inputs: Home_Hero_Hasachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Есть достижения`)
};

const uk_home_hero_hasachievements1 = /** @type {(inputs: Home_Hero_Hasachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Має досягнення`)
};

const ar_home_hero_hasachievements1 = /** @type {(inputs: Home_Hero_Hasachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لديه إنجازات`)
};

const hi_home_hero_hasachievements1 = /** @type {(inputs: Home_Hero_Hasachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपलब्धियाँ हैं`)
};

const th_home_hero_hasachievements1 = /** @type {(inputs: Home_Hero_Hasachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`มีความสำเร็จ`)
};

const ja_home_hero_hasachievements1 = /** @type {(inputs: Home_Hero_Hasachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`実績あり`)
};

const zh_cn2_home_hero_hasachievements1 = /** @type {(inputs: Home_Hero_Hasachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`包含成就`)
};

const zh_hant1_home_hero_hasachievements1 = /** @type {(inputs: Home_Hero_Hasachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`包含成就`)
};

const ko_home_hero_hasachievements1 = /** @type {(inputs: Home_Hero_Hasachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`도전 과제 있음`)
};

/**
* | output |
* | --- |
* | "Has achievements" |
*
* @param {Home_Hero_Hasachievements1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_hero_hasachievements1 = /** @type {((inputs?: Home_Hero_Hasachievements1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_Hasachievements1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_hero_hasachievements1(inputs)
	if (locale === "ms") return ms_home_hero_hasachievements1(inputs)
	if (locale === "da") return da_home_hero_hasachievements1(inputs)
	if (locale === "de") return de_home_hero_hasachievements1(inputs)
	if (locale === "en-US") return en_us2_home_hero_hasachievements1(inputs)
	if (locale === "es-ES") return es_es2_home_hero_hasachievements1(inputs)
	if (locale === "es-MX") return es_mx2_home_hero_hasachievements1(inputs)
	if (locale === "fil") return fil_home_hero_hasachievements1(inputs)
	if (locale === "fr") return fr_home_hero_hasachievements1(inputs)
	if (locale === "it") return it_home_hero_hasachievements1(inputs)
	if (locale === "hu") return hu_home_hero_hasachievements1(inputs)
	if (locale === "nl") return nl_home_hero_hasachievements1(inputs)
	if (locale === "no") return no_home_hero_hasachievements1(inputs)
	if (locale === "pl") return pl_home_hero_hasachievements1(inputs)
	if (locale === "pt-BR") return pt_br2_home_hero_hasachievements1(inputs)
	if (locale === "pt") return pt_home_hero_hasachievements1(inputs)
	if (locale === "ro") return ro_home_hero_hasachievements1(inputs)
	if (locale === "fi") return fi_home_hero_hasachievements1(inputs)
	if (locale === "sv") return sv_home_hero_hasachievements1(inputs)
	if (locale === "vi") return vi_home_hero_hasachievements1(inputs)
	if (locale === "tr") return tr_home_hero_hasachievements1(inputs)
	if (locale === "cs") return cs_home_hero_hasachievements1(inputs)
	if (locale === "bg") return bg_home_hero_hasachievements1(inputs)
	if (locale === "ru") return ru_home_hero_hasachievements1(inputs)
	if (locale === "uk") return uk_home_hero_hasachievements1(inputs)
	if (locale === "ar") return ar_home_hero_hasachievements1(inputs)
	if (locale === "hi") return hi_home_hero_hasachievements1(inputs)
	if (locale === "th") return th_home_hero_hasachievements1(inputs)
	if (locale === "ja") return ja_home_hero_hasachievements1(inputs)
	if (locale === "zh-CN") return zh_cn2_home_hero_hasachievements1(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_hero_hasachievements1(inputs)
	return ko_home_hero_hasachievements1(inputs)
});
export { home_hero_hasachievements1 as "home.hero.hasAchievements" }